<template>
  <div>
    <div ref="barcodeContainer" class="label">
      <svg ref="barcode" class="barcode"></svg>
    </div>
    <button @click="printLabel">Print Label</button>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";

export default {
  data() {
    return {
      barcodeValue: "1234567890", // Your barcode value
      labelWidth: 300,  // Width of the label
      labelHeight: 150, // Height of the label
      marginTop: 10,    // Top margin
      marginLeft: 10,   // Left margin
      marginBottom: 10, // Bottom margin
      marginRight: 10,  // Right margin
    };
  },
  methods: {
    generateBarcode() {
      JsBarcode(this.$refs.barcode, this.barcodeValue, {
        format: "CODE128",   // Barcode format (e.g., CODE128, EAN13)
        width: 2,            // Width of the bars
        height: 50,          // Height of the barcode
        displayValue: true,  // Display the barcode value
        fontSize: 18,        // Font size for the value
      });
    },
    printLabel() {
      const label = this.$refs.barcodeContainer;
      const printWindow = window.open("", "_blank");
      
      // Styling for the print layout
      printWindow.document.write(`
        <html>
          <head>
            <style>
              body {
                margin: 0;
                padding: 0;
                font-family: Arial, sans-serif;
              }
              .label {
                width: ${this.labelWidth}px;
                height: ${this.labelHeight}px;
                padding: ${this.marginTop}px ${this.marginRight}px ${this.marginBottom}px ${this.marginLeft}px;
                border: 1px solid #000;
                display: flex;
                justify-content: center;
                align-items: center;
                page-break-before: always;
              }
              .barcode {
                width: 100%;
              }
            </style>
          </head>
          <body>
            <div class="label">
              ${label.innerHTML}
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  },
  mounted() {
    this.generateBarcode();
  }
};
</script>

<style scoped>
/* Optional: Add custom styles for the label */
.label {
  display: flex;
  justify-content: center;
  align-items: center;
}
.barcode {
  width: 100%;
}
</style>
